import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-print",
  "use": "icon-print-usage",
  "viewBox": "0 0 359.257 314.349",
  "content": "<symbol viewBox=\"0 0 359.257 314.349\" id=\"icon-print\">\r\n<g>\r\n\t<path d=\"M74.697,314.349V208.985H0V76.004h359.257V208.63h-74.48v105.719H74.697z M254.561,180.022\r\n\t\tH104.997v104.31h149.563V180.022z M337.077,127.156c-0.048-12.461-10.197-22.531-22.618-22.439\r\n\t\tc-12.391,0.092-22.437,10.393-22.244,22.81c0.191,12.287,10.135,22.158,22.358,22.197\r\n\t\tC326.959,149.763,337.124,139.569,337.077,127.156\" />\r\n\t<rect x=\"74.868\" width=\"209.532\" height=\"59.353\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/print.svg
// module id = ./app/general/svg/print.svg
// module chunks = app